var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIconBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3C9.5 3.53043 9.71071 4.03914 10.0858 4.41421C10.4609 4.78929 10.9696 5 11.5 5C12.0304 5 12.5391 4.78929 12.9142 4.41421C13.2893 4.03914 13.5 3.53043 13.5 3M9.5 3C9.5 2.46957 9.71071 1.96086 10.0858 1.58579C10.4609 1.21071 10.9696 1 11.5 1C12.0304 1 12.5391 1.21071 12.9142 1.58579C13.2893 1.96086 13.5 2.46957 13.5 3M9.5 3H1.5M13.5 3H17.5M3.5 9C3.5 9.53043 3.71071 10.0391 4.08579 10.4142C4.46086 10.7893 4.96957 11 5.5 11C6.03043 11 6.53914 10.7893 6.91421 10.4142C7.28929 10.0391 7.5 9.53043 7.5 9M3.5 9C3.5 8.46957 3.71071 7.96086 4.08579 7.58579C4.46086 7.21071 4.96957 7 5.5 7C6.03043 7 6.53914 7.21071 6.91421 7.58579C7.28929 7.96086 7.5 8.46957 7.5 9M3.5 9H1.5M7.5 9H17.5M12.5 15C12.5 15.5304 12.7107 16.0391 13.0858 16.4142C13.4609 16.7893 13.9696 17 14.5 17C15.0304 17 15.5391 16.7893 15.9142 16.4142C16.2893 16.0391 16.5 15.5304 16.5 15M12.5 15C12.5 14.4696 12.7107 13.9609 13.0858 13.5858C13.4609 13.2107 13.9696 13 14.5 13C15.0304 13 15.5391 13.2107 15.9142 13.5858C16.2893 13.9609 16.5 14.4696 16.5 15M12.5 15H1.5M16.5 15H17.5",
    stroke: "#2191F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconBlue);
export default __webpack_public_path__ + "static/media/filter-icon-blue.777e71e19c9e6a11048d445934666907.svg";
export { ForwardRef as ReactComponent };